module.exports = require("lodash.isobject");


//////////////////
// WEBPACK FOOTER
// external "lodash.isobject"
// module id = 3
// module chunks = 0